/* What the signed-in admin may do, as the server decided at login
   (`capabilities` in the login response, from billing/permissions.py).

   The UI only hides what would be refused anyway — the server checks every
   request. A session saved before logins carried the list falls back to the
   roles that held every billing capability when it was introduced, so nobody
   loses the Billing screens until they next sign in. */
const LEGACY_FULL_ACCESS_ROLES = ['SUPER_ADMIN', 'GH_ADMIN'];

export function hasCapability(user, capability) {
  if (!user) return false;
  if (Array.isArray(user.capabilities)) return user.capabilities.includes(capability);
  return LEGACY_FULL_ACCESS_ROLES.includes(user.apiRole);
}
